import React, { type PropsWithChildren } from 'react';
import { graphql, useFragment } from 'react-relay';
import { FormatRulesContainer } from '@atlassian/jira-business-conditional-formatting-sidebar/src/controllers/format-rules-store/index.tsx';
import { FormatRulesFragment } from '@atlassian/jira-business-conditional-formatting-sidebar/src/ui/format-rules/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner$key } from '@atlassian/jira-relay/src/__generated__/container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner.graphql';
import { JqlProvider } from '@atlassian/jira-business-entity-common/src/controllers/jql-context/index.tsx';
import { ConditionalFormattingEntrypointProvider } from '@atlassian/jira-issue-navigator-action-conditional-formatting/src/controllers/entrypoint-context/index.tsx';

export const ConditionalFormattingInner = ({
	project,
	children,
}: PropsWithChildren<{
	project: container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner$key | null;
}>) => {
	const projectData =
		useFragment<container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner$key>(
			graphql`
				fragment container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner on JiraProject
				@argumentDefinitions(first: { type: "Int!" }) {
					key
					...formatRules_businessConditionalFormattingSidebar_FormatRulesFragment
						@arguments(first: $first)
				}
			`,
			project,
		);

	if (projectData != null) {
		return (
			<FormatRulesContainer>
				<JqlProvider jqlContext={`project = '${projectData.key}'`}>
					<ConditionalFormattingEntrypointProvider projectKey={projectData.key}>
						{children}
					</ConditionalFormattingEntrypointProvider>
				</JqlProvider>
				<FormatRulesFragment project={projectData} />
			</FormatRulesContainer>
		);
	}

	return children;
};

export const ConditionalFormatting = ({
	isEnabled,
	...rest
}: PropsWithChildren<{
	isEnabled?: boolean;
	project: container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner$key | null;
}>) => {
	if (isEnabled && fg('jira_list_conditional_formatting')) {
		return <ConditionalFormattingInner {...rest} />;
	}
	return rest.children;
};
